import { useDispatch, useSelector } from "react-redux";
import { Types } from "Types";
import {
  Selectors as AdbSelector,
  ActionCreators as AdbActionCreators,
} from "../../../redux/AdministrateurDeBien";
import { ActionCreators as BienActionCreators } from "../../../redux/Bien";
import {
  ActionCreators as DossierLocationActionCreators,
  Selectors as DossierLocationSelectors,
} from "../../../redux/DossierLocation";
import { ActionCreators as SituationPersonnelleActionCreator } from "../../../redux/SituationPersonnelle";
import { ActionCreators as SituationProActionCreator } from "../../../redux/SituationProfessionnelle";
import { Selectors as UtilisateursSelectors } from "../../../redux/Utilisateurs";
import { DossiersLocationProps } from "../../../services/Api/DossierLocation";
import {
  useAccepterDossier,
  useAnnulerAcceptationDossier,
  useDeleteDossierLocation,
  useGenererCertification,
  useGetDossiersLocation,
} from "../../../hooks/DossierLocation";
import { useNavigate } from "react-router";
import { useGetAdbDetail } from "../../../hooks/AdministrateurDeBien";
import { useEffect } from "react";

export const useDashboard = () => {
  const utilisateurConnecte = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getUtilisateurConnecte(state)
  );
  const utilisateurFetching = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getUtilisateurFetching(state)
  );
  // const utilisateurError = useSelector((state: Types.RootState) =>
  //   UtilisateursSelectors.getUtilisateurError(state)
  // );
  const accepterRefuserLocationError = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getAccepterRefuserLocationError(state)
  );
  // const dossiersLocation = useSelector((state: Types.RootState) =>
  //   DossierLocationSelectors.getResultDossierLocation(state)
  // );

  const { mutate: mutateADBIdDetail } = useGetAdbDetail();

  const isAccepterRefuserLocationLoading = useSelector(
    (state: Types.RootState) =>
      DossierLocationSelectors.getAccepterRefuserLocationFetching(state)
  );

  const genererLoading = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getGenererFetching(state)
  );
  const genererError = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getGenererError(state)
  );
  const idAdb = useSelector((state: Types.RootState) =>
    AdbSelector.getAdbId(state)
  );
  const infoProfil = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getProfilUtilisateur(state)
  );
  const retourLocationAcceptee = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getRetourLocationAcceptee(state)
  );

  const adbDetail = useSelector((state: Types.RootState) =>
    AdbSelector.getADBDetail(state)
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(DossierLocationActionCreators.resetDuplicationDossier());
    if (
      utilisateurConnecte?.role === "ADB" &&
      utilisateurConnecte?.detailAdbProfilSites
    ) {
      mutateADBIdDetail(utilisateurConnecte?.detailAdbProfilSites[0].refAdb);
    }
  }, [utilisateurConnecte?.role]);
  //
  //
  const redirectCreationBien = () => {
    // dispatch(DossierLocationActionCreators.redirectSelectAdbSitePage());

    // const findAdb = adbDetail?.find((adb) => adb.identifiant === idAdb);
    if (
      utilisateurConnecte?.role === "ADB" &&
      utilisateurConnecte?.detailAdbProfilSites?.length === 1 &&
      utilisateurConnecte?.detailAdbProfilSites[0].sites?.length === 1
    ) {
      // let selectedAdb = adbDetail?.find(
      //   (s) =>
      //     utilisateurConnecte?.detailAdbProfilSites &&
      //     utilisateurConnecte.detailAdbProfilSites[0].refAdb === s.identifiant
      // );

      if (adbDetail) {
        const refSite = utilisateurConnecte.detailAdbProfilSites[0].sites[0];
        const selectedSite = adbDetail.sites?.find((s) => s.numero === refSite);
        if (selectedSite) {
          dispatch(AdbActionCreators.setSelectedSite(selectedSite));
          navigate("/dossier-location/bien");
        }
      } else {
        navigate("/dossier-location/selection-adb");
      }
    } else if (utilisateurConnecte?.role === "BESSE" && idAdb && adbDetail) {
      const sites = adbDetail.sites;
      const site = sites && sites[0];
      if (sites?.length === 1) {
        site && dispatch(AdbActionCreators.setSelectedSite(site));
        navigate("/dossier-location/bien");
      } else {
        navigate("/dossier-location/selection-adb");
      }
    } else {
      navigate("/dossier-location/selection-adb");
    }
    dispatch(
      DossierLocationActionCreators.resetDossierLocationParcoursCreation()
    );
    dispatch(BienActionCreators.resetBienParcoursCreation());
    dispatch(
      SituationPersonnelleActionCreator.resetSituationPersonnelleParcoursCreation()
    );
    dispatch(SituationProActionCreator.resetSituationProParcoursCreation());
  };

  // const getDossiersLocation = (params: DossiersLocationProps) => {
  //   dispatch(DossierLocationActionCreators.getDossiersLocation.request(params));
  // };

  const {
    mutate: mutateDossiersLocation,
    isLoading: resultFetching,
    error: resultError,
    data: dossiersLocation,
  } = useGetDossiersLocation();
  const getDossiersLocation = (params: DossiersLocationProps) => {
    mutateDossiersLocation(params);
  };
  const setSelectedDossier = (refLocation: string) => {
    dispatch(DossierLocationActionCreators.setSelectedDossier(refLocation));
  };
  const setDuplicationDossier = (refLocation: string) => {
    dispatch(DossierLocationActionCreators.setDuplicationDossier(refLocation));
  };

  const { mutate: accepterDossier, isSuccess: isSuccessAccepterDossier } =
    useAccepterDossier();
  const {
    mutate: annulerAcceptationDossier,
    isSuccess: isSuccessAnnulerAccepterDossier,
  } = useAnnulerAcceptationDossier();
  const setAcceptationDossier = (refLocation: string) => {
    accepterDossier(refLocation);
  };
  const setAnnulerAcceptationDossier = (refLocation: string) => {
    annulerAcceptationDossier(refLocation);
  };
  const supprimerErrorDossierLocation = () => {
    dispatch(
      DossierLocationActionCreators.supprimerAcceptationOuRefusDossierError()
    );
  };
  const setFiltreRechercheDossier = (params: any) => {
    dispatch(DossierLocationActionCreators.setFiltreRechercheDossiers(params));
  };

  const { mutate: mutateDeleteDossierLocation } = useDeleteDossierLocation();
  const deleteDossierLocation = (ref: string) => {
    mutateDeleteDossierLocation(ref);
  };

  const { mutate: mutateGenererCertification } = useGenererCertification();
  const genererCertification = (ref: string) => {
    mutateGenererCertification(ref);
  };

  //  CONFIRMATION CREATION DOSSER LOCATION CANDIDAT LOCATAIRE

  const confirmationCreationDossierLocation = useSelector(
    (state: Types.RootState) =>
      state.dossierLocation.confirmationCreationDossierLocation
  );

  const onCloseConfirmationCreationDossierLocation = () => {
    dispatch(
      DossierLocationActionCreators.resetConfirmationCreationDossierLocation()
    );
  };

  const displayCandidatLocataire =
    adbDetail?.habilitations?.parcoursCandidatLocataire;
  return {
    utilisateurConnecte,
    utilisateurFetching,
    accepterRefuserLocationError,
    dossiersLocation,
    resultFetching,
    isAccepterRefuserLocationLoading,
    genererError,
    genererLoading,
    resultError,
    idAdb,
    infoProfil,
    retourLocationAcceptee,
    // ACTIONS
    redirectCreationBien,
    getDossiersLocation,
    setSelectedDossier,
    setDuplicationDossier,
    setAcceptationDossier,
    setAnnulerAcceptationDossier,
    supprimerErrorDossierLocation,
    setFiltreRechercheDossier,
    deleteDossierLocation,
    genererCertification,
    isSuccessAccepterDossier,
    isSuccessAnnulerAccepterDossier,
    onCloseConfirmationCreationDossierLocation,
    confirmationCreationDossierLocation,
    displayCandidatLocataire,
  };
};
